<template>
    <v-container
      class="ma-0 pa-0"
      fluid
      style="height: calc(100vh - 96px); max-height: calc(100vh - 96px); overflow-y: hidden; width: 100%"
    >
      <div v-if="showAlert">
        <v-alert
          class="v-alert alert_overlay"
          v-model="showAlert"
          border="left"
          close-text="Close Alert"
          dismissible
          :type="alertType"
        >
          {{ alertMsg }}
        </v-alert>
      </div>
      <v-row v-if="export_overlay">
        <v-col cols="12">
          <v-overlay :absolute="true" :value="export_overlay" :z-index="999">
            <v-card class="pa-3 overlay_card">
              <v-row justify="center" align="center" style="height: 100%; width: 100%">
                <v-col cols="auto">
                  <v-progress-circular indeterminate size="300" color="black">
                    <v-row
                      style="height: 100%; width: 100%"
                      align="center"
                      justify="center"
                  >
                      <v-col cols="auto" align="center">
                        <span>Please Allow us a Few Minutes to Generate your Export</span>
                      </v-col>
                    </v-row>
                  </v-progress-circular>
                </v-col>
              </v-row>
            </v-card>
          </v-overlay>
        </v-col>
      </v-row>
      <v-row class="ma-0 pa-0" style="height: 100%">
        <v-col cols="12" class="ma-0 pa-0" style="height: 100%">
          <!-- Title And Highlights Row-->
          <v-row style="min-height: 10%; max-height: 20" class="ma-0 px-6 pt-4 pb-2">
            <!-- Title Column-->
            <v-col cols="12" class="ma-0 pa-0">
              <v-row width="100%" class="ma-0 pa-0" align="center" style="min-height: 60px;">
                <v-col cols="auto" class="ma-0 pa-0">
                  <v-img :src="main_logo" max-height="48px" max-width="80px" contain></v-img>
                </v-col>
                <v-col cols="auto" class="ma-0 pa-0">
                  <span class="page-title">{{ pageTitle }}</span>
                </v-col>
                <v-spacer></v-spacer>
                <!-- <v-col v-if="ort_tab=='overview'" sm="6" md="5" lg="4" class="ma-0 pa-0">
                  <v-row class="ma-0 pa-0" style="height: 100%; width: 100%;">
                    <v-col cols="4" class="ma-0 pa-0">
                      <PerformanceMainStatistic statistic_title_name="Reach %" :value="rch_highlight"/>
                    </v-col>
                    <v-col cols="4" class="ma-0 pa-0">
                      <PerformanceMainStatistic statistic_title_name="Avg. Frequency" :value="frq_highlight"/>
                    </v-col>
                    <v-col cols="4" class="ma-0 pa-0">
                      <PerformanceMainStatistic statistic_title_name="Impression" :value="imp_highlight"/>
                    </v-col>
                  </v-row>
                </v-col> -->
              </v-row>
              <v-row width="100%" class="ma-0 pa-0">
                <v-tabs v-model="ort_tab" align-tabs="start" light>
                  <v-tab class="tool-navigation-bar" href="#saved">My ORT Reports</v-tab>
                  <v-tab :disabled="ort_tab == 'saved'" class="tool-navigation-bar" href="#overview">Report Overview</v-tab>
                </v-tabs>
              </v-row>
            </v-col>
          </v-row>
          <v-tabs-items
            class="ma-0 pa-0"
            v-model="ort_tab"
            style="height: calc(100vh - 230px); max-height: calc(100vh - 230px); width: 100%"
          >
            <v-tab-item
              style="height: 100%; max-height: 100%; width: 100%"
              value="saved"
            >
              <v-row width="100%" style="min-height: 10%; height: 100%" class="ma-0 pa-0">
                <ORTSaved
                  v-on:triggerAlert="triggerAlert"
                  v-on:open_report="open_report"
                >
                </ORTSaved>
              </v-row>
            </v-tab-item>
            <v-tab-item
              style="height: 100%; max-height: 100%; width: 100%; overflow-y:auto;"
              value="overview"
            >
              <v-row width="100%" style="min-height: 10%" class="ma-0 pa-0">
                <ORTOverview
                  v-on:reportHighlights="set_highlights"
                  v-on:triggerAlert="triggerAlert"
                  v-on:toggleExportOverlay="toggleExportOverlay"
                  :report_id="ort_report_id"
                >
                </ORTOverview>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import logo from "@/assets/ORTLogo.png";
  import ORTSaved from "@/components/ORT/ORTPages/ORTSaved.vue";
  import ORTOverview from "@/components/ORT/ORTPages/ORTOverview.vue";
  //import PerformanceMainStatistic from "@/components/Performance/PerformanceStats/PerformanceReportSections/PerformanceMainStatistic.vue";
  
  export default {
    name: "ORTBasePage",
    components: {
        ORTSaved,
        ORTOverview,
        // PerformanceMainStatistic
    },
    mounted() {
    },
    beforeDestroy() {
      clearTimeout(this.alertTimeout);
    },
    watch: {
    },
    computed: {
      pageTitle: function () {
        if (this.$vuetify.breakpoint.mdAndDown) {
          return 'ORTs'
        }
        return 'Omni-Channel Resolution Tags'
      }
    },
    data: () => ({
      alertMsg: null,
      alertType: null,
      showAlert: false,
      alertTimeout: null,
      main_logo: logo,
      new_plan_title: '',
      ort_tab: "saved",
      report_opened: false,
      ort_report_id: 0,
      export_overlay: false,

      rch_highlight: null,
      frq_highlight: null,
      imp_highlight: null
    }),
    methods: {
      triggerAlert: function (type, message) {
        this.alertType = type ? type : "info";
        this.alertMsg = message;
        this.showAlert = true;
        clearTimeout(this.alertTimeout);
        this.alertTimeout = setTimeout(() => {
          this.showAlert = false;
          this.alertTimeout = null;
        }, 5000);
      },
      toggleExportOverlay: function (status) {
        this.export_overlay = status;
      },
      open_report: function (report_id) {
        this.ort_report_id = report_id;
        this.ort_tab = 'overview';
        
        this.rch_highlight = null;
        this.frq_highlight = null;
        this.imp_highlight = null;
      },
      set_highlights: function (highlights){
        this.rch_highlight = ((highlights['reach'] * 100).toFixed(2)).toString() + '%';
        this.frq_highlight = highlights['frequency'].toFixed(2).toString();
        this.imp_highlight = Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 }).format(highlights['impressions']);
      }
    },
  };
  </script>
  
  <style scoped>
  .page-title {
    font-family: "Poppins" !important;
    font-weight: 800;
    font-size: 2em;
  }

  .tool-navigation-bar {
    font-family: "Poppins" !important;
    font-weight: 400 !important;
    font-size: 0.9em !important;
  }
  
  /deep/.v-window__container {
    height: 100% !important;
  }

  .v-alert {
    position: fixed;
    left: 50%;
    /* bottom: 50px; */
    width: 100%;
    transform: translate(-50%, 0%);
    z-index: 2;
    /* margin: 0 0; */
  }
  .alert_overlay {
    position: absolute;
    width: 100%;
    z-index: 99;
  }
  .overlay_card {
    background: white;
    position: fixed;
    height: 100vh;
    width: 100%;
    left: 0;
    right: 0;
    top: 0px;
  }
  </style>
  
